import React from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import classnames from 'classnames';
import {Anchor} from '@albert-io/atomic';
import './collapsible-list.scss';

export default class CollapsibleList extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    inline: PropTypes.bool,
    items: ImmutablePropTypes.listOf(PropTypes.string).isRequired,
    maxVisibleItems: PropTypes.number
  };

  static defaultProps = {
    maxVisibleItems: 3
  };

  constructor(props) {
    super(props);

    this.state = {
      isExpanded: false
    };
  }

  getItemsToShow() {
    return this.state.isExpanded
      ? this.props.items
      : this.props.items.slice(0, this.props.maxVisibleItems);
  }

  handleKeyPress = (e) => {
    e.persist();
    e.preventDefault();
    if (e.key === ' ') {
      this.handleToggle(e);
    }
  };

  handleToggle = (e) => {
    e.preventDefault();
    this.setState(({isExpanded}) => ({isExpanded: !isExpanded}));
  };

  render() {
    const {isExpanded} = this.state;

    const {className, inline, items, maxVisibleItems} = this.props;
    const punctuatedItemNames = items.join(', %').split('%');

    const itemsToShow = this.getItemsToShow();

    const listItems = items.map((item, i) => (
      <li
        aria-hidden={itemsToShow.includes(item)}
        className={classnames('collapsible-list__list-item', {
          'collapsible-list__list-item--inline': inline,
          'collapsible-list__list-item--is-expanded': itemsToShow.includes(item)
        })}
        // eslint-disable-next-line react/no-array-index-key
        key={i}
      >
        {punctuatedItemNames[i]}
      </li>
    ));

    return (
      <>
        <ul
          className={classnames('collapsible-list__list', className, {
            'collapsible-list__list--inline': inline
          })}
        >
          {listItems}
        </ul>
        {items.size > maxVisibleItems ? (
          <Anchor
            aria-expanded={isExpanded}
            className={classnames('collapsible-list__toggle-btn', 'uppercase', {
              'collapsible-list__toggle-btn--inline': inline
            })}
            onClick={this.handleToggle}
            onKeyPress={this.handleKeyPress}
            role='button'
            tabIndex={0}
          >
            {isExpanded ? 'Hide' : `${items.slice(maxVisibleItems, items.size).size} more...`}
          </Anchor>
        ) : null}
      </>
    );
  }
}
